import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Details.css";

export default function Details() {
  return (
    <div>
      <Container className="py-5">
        <div>
          <h3>Schools and Partners</h3>
          <p className="text-gray">
            Hub Educational offers the highest quality online courses from
            institutions who share our commitment to excellence in teaching and
            learning.
          </p>
        </div>
        <Row className="text-center">
          <Col>
            <div className="number-background">2,800 +</div>
            <div className="text-darkgray">
              courses in subjects such as humanities, math, computer science
            </div>
          </Col>
          <Col>
            <div className="number-background">34 Million +</div>
            <div className="text-darkgray">
              courses in subjects such as humanities, math, computer science
            </div>
          </Col>
          <Col>
            <div className="number-background">100 Million +</div>
            <div className="text-darkgray">
              enrollments across Hub Educational courses
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
